var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7777 8.03201H11.493V11.3021H14.7777V8.03201Z",
    fill: "#ED008C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.72913 8.03201H1.44438V11.3021H4.72913V8.03201Z",
    fill: "#ED008C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.33314 1.50489H9.72287C12.24 1.50489 13.4132 2.81851 13.9035 6.3217L14.6829 6.28808L14.5789 0.730011H1.77028L1.64404 6.28808L2.39411 6.3217C2.52401 5.00808 2.67982 4.30064 3.01794 3.5932C3.61566 2.27938 4.86312 1.50489 6.39629 1.50489H6.94201V13.5975C6.94201 14.8775 6.86411 15.2817 6.5525 15.5849C6.29249 15.8206 5.77266 15.9217 5.17473 15.9217H4.577V16.73H11.6981V15.9217H11.0967C10.5027 15.9217 9.9792 15.8204 9.72307 15.5849C9.4112 15.2817 9.33334 14.8773 9.33334 13.5975L9.33314 1.50489Z",
    fill: "#ED008C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTMobile);
export default __webpack_public_path__ + "static/media/TMobile.f4d9dfbe0fbfb6c8055152a0b2858310.svg";
export { ForwardRef as ReactComponent };